<!-- 店铺简介 -->
<template>
  <div style="margin: 20px 0 0 50px;">
    <!-- 店铺简介模块 -->
    <h2 style="font-size: 18px;margin: 30px 0 20px 30px;">店铺简介</h2>
    <el-row>
      <el-col :span="24" style="margin-left: 40px;">
        <el-form>
          <!-- 店铺详细介绍（长文本，选填） -->
          <el-form-item label="详细介绍 :" label-width="120px">
            <el-input type="textarea" maxlength="500" v-model="shopIntroDetail" placeholder="请输入店铺详细介绍（选填）" :rows="5"
              style="width: 80%;" />
          </el-form-item>
          <!-- 简介展示图片（选填，复用原有展示图片逻辑，最多5张，1200*675，仅支持jpg/png） -->
          <el-form-item label="展示图片 :" label-width="120px">
            <div style="display:flex;flex-wrap:wrap">
              <div v-for="(item, index) in introImgArr" :key="index"
                style="display:inline-block; position: relative;height:80px;">
                <img src="../../assets/img/aicon36.png" @click="deleteIntroImg(index)"
                  style="position:absolute;right:6px;top:-8px;z-index: 1;width: 20px;cursor: pointer;" />
                <el-image :src="item" @click="handleClickItem" :preview-src-list="introImgArr" fit="cover"
                  style="width:80px;height:80px;display:inline-block;margin-right:15px;" />
              </div>
              <div class="upload" style="display:inline-block;" v-show="introImgArr.length < 5">
                <el-upload v-show="introImgDisabled" class="avatar-uploader-zstp" action accept=".jpg,.png"
                  :show-file-list="false" :before-upload="beforeUploadIntroImg">
                  <i class="el-icon-plus avatar-uploader-icon" />
                </el-upload>
              </div>
            </div>
            <div style="color:#888;margin-top:8px;">建议尺寸：1200*675，支持的图片格式：jpg、png。（选填）</div>
            <canvas id="canvasa" hidden />
          </el-form-item>
          <!-- 简介展示视频（选填，复用原有视频上传逻辑，仅支持mp4/50MB内） -->
          <el-form-item label="展示视频 :" label-width="120px">
            <div v-if="introVideoSrc" class="videoClass">
              <div @click="newSeevideo(introVideoSrc)" class="previewingVideo">
                <img :src="introVideoImg" v-if="introVideoImg">
                <img src="../../assets/img/spfm.png" v-else>
                <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon" /></div>
              </div>
              <img src="../../assets/img/aicon36.png" @click="delIntroVideo()" v-if="introVideoSrc" class="chahao"
                style="cursor: pointer;" />
            </div>
            <!-- 修正：accept改为仅video/mp4，精准限制mp4格式，和原有模块保持一致 -->
            <el-upload v-else class="avatar-uploader-zstp" action="" accept="video/mp4"
              :before-upload="handleIntroFile">
              <el-progress type="circle" v-if="introVideoFlag" :percentage="introVideoUploadPercent" :width="80"
                :height="80" />
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
            <div style="color:#888;margin-top:8px;">视频格式仅支持: mp4. 视频大小不能超过 50MB !（选填）</div>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div style="text-align:center;margin-bottom: 20px;">
      <el-button @click="goback()">取消</el-button>
      <el-button type="danger" @click="emit()">确定</el-button>
    </div>

    <!-- 播放视频 -->
    <el-dialog title='视频播放' :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
      <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true"
        :options="playerOptions" />
    </el-dialog>
    <!-- vueCropper 剪裁图片实现-->
    <el-dialog title="图片剪裁" :visible.sync="cropping" append-to-body center>
      <div class="cropper-content">
        <div class="cropper">
          <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :fixedBox="option.fixedBox"
            :outputType="option.outputType" :full="option.full" :canMove="option.canMove" :infoTrue="option.infoTrue"
            :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :info="true"
            :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
            :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cropping = false">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getStoreGift, putStoreGift } from "../../api/shopWindow";


import { BMap } from 'vue-baidu-map';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, postAddFile, uploadVedio, provincegetcountys } from '../../api/newOss';
import { getkind, SelectDesignerSkilledDoMainBaseData } from "../../api/api";
import { intro, introsave } from "../../api/attractInvestment";
import { rolegetlist, userroleset, } from "../../api/comment";
export default {
  name: "dpjj",
  data() {
    return {
      videoImg: '', // 视频封面图
      videoSrc: "", // 全连接
      videoShortSrc: "", // 切割之后链接
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false, // 视频播放
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },

      cropping: false, // 图片裁剪弹框
      distinguish: '', // 区分两个上传图片
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1200, // 默认生成截图框宽度
        autoCropHeight: 675, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1200, 675], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },

      shopIntroDetail: '', // 店铺详细介绍文本
      introImgArr: [], // 店铺简介-展示图片列表（对应原有imgShopArr）
      introOnePic: [], // 店铺简介-图片文件记录数组（对应原有onePic）
      introImgDisabled: true, // 店铺简介-图片上传按钮显隐控制（最多5张，对应原有isdisabled）
      introImgarrCutting: '', // 店铺简介-图片短链接（去除OSS前缀）

      // 店铺简介-视频相关字段（和原有视频字段一一对应，完全隔离）
      introVideoSrc: "", // 店铺简介-视频完整长链接
      introVideoShortSrc: "", // 店铺简介-视频短链接（去除OSS前缀）
      introVideoImg: '', // 店铺简介-视频封面图
      introVideoFlag: false, // 店铺简介-视频上传进度条显隐
      introVideoUploadPercent: 0, // 店铺简介-视频上传进度百分比
      introVideoTimer: null, // 店铺简介-视频进度条定时器

      // 图片剪裁模块区分标记（核心：隔离两个模块的剪裁逻辑）
      cropType: '', // shop=店铺基本信息展示图，intro=店铺简介展示图
    };
  },
  methods: {
    // 回显数据
    getinfobyId() {
      var obj = {
        bbid: localStorage.businessBbId
        // queryType: 3
      };
      let bbid = localStorage.businessBbId;
      intro({}, bbid).then(data => {
        if (data.resultCode == 1) {
          this.shopinfo = data.resultObj;
          this.shopIntroDetail = this.shopinfo.intro || '';
          // 简介展示图片回显（拼接OSS完整地址，和原有逻辑一致）
          this.introImgArr = this.shopinfo.imgs
            ? this.shopinfo.imgs.map(item => localStorage.BaseOssUrl + item)
            : [];
          // 简介视频回显（完整地址+短链接+封面图，和原有逻辑一致）
          this.introVideoShortSrc = this.shopinfo.video_url || '';
          this.introVideoSrc = this.introVideoShortSrc
            ? localStorage.BaseOssUrl + this.shopinfo.video_url
            : '';
          this.introVideoImg = this.introVideoShortSrc
            ? localStorage.BaseOssUrl + this.shopinfo.video_cover.replace('.m3u8', '.png')
            : '';
          // 简介图片上传按钮显隐控制
          this.introImgDisabled = this.introImgArr.length < 5;

        }
      });
    },
    // 保存修改
    emit() {
      // this.introImgArr = this.introImgArr.map(item => item.replace('', localStorage.BaseOssUrl)); // 展示图片集合
      var obj = {
        // UserId: localStorage.Id,
        shopid: localStorage.businessBbId,
        intro: this.shopIntroDetail, // 店铺简介
        video_url: this.introVideoShortSrc, // 店铺简介视频地址 相对路径
        imgs: this.introImgArr.map(item => item.replace(localStorage.BaseOssUrl, '')), // 店铺简介图片地址
        video_cover: this.introVideoImg.replace(localStorage.BaseOssUrl, '')
      };
      console.log(obj,this.introImgArr,this.introOnePic)
      introsave(obj).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: "保存成功"
          })
        }
      });
    },

    // 返回
    goback() {
      this.$router.go(-1);
    },

      /**
   * 店铺简介-展示图片上传前校验&处理
   * 1:1对齐原有beforeUploadShopIntroduction逻辑，仅修改目标字段
   */
    beforeUploadIntroImg(file) {
      // 新增：严格校验图片格式，仅支持jpg、png
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        this.$swal({
          type: "warning",
          text: "上传图片格式仅支持jpg、png！"
        });
        return false;
      }

      // 尺寸校验：强制1200*675，和原有规范完全一致
      const isSize = new Promise(function (resolve, reject) {
        const width = 1200;
        const height = 675;
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.onload = function () {
          const valid = img.width === width && img.height === height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })

      // 大小校验：最大5MB，和原有规范完全一致
      const isLt5M = file.size / 1024 / 1024 <= 5;
      if (!isLt5M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 5MB!"
        });
        return false;
      }

      // 尺寸符合：直接OSS上传并回显到店铺简介图片列表
      isSize.then(async () => {
        const that = this;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function () {
          // 复用原有OSS配置获取逻辑，type和原有保持一致38
          const ossParams = { type: 38 };
          getOssFile(ossParams).then(data => {
            that.fileName = file.name;
            if (data.resultCode == 1) {
              const { accesskeyid, accesskeysecret, hostendpoint, directory, bucket } = data.resultObj;
              localStorage.setItem('keyossId', accesskeyid);
              localStorage.setItem('keyossSecret', accesskeysecret);
              localStorage.setItem('keyossHost', hostendpoint);
              localStorage.setItem('keyossfile', directory);
              localStorage.setItem('keyossbucket', bucket);
            }
          })
          // 复用原有OSS上传方法
          const newOssPic = await uploadOSS(file, 0);
          // 回显到店铺简介专属图片列表
          that.introImgArr.push(newOssPic);
          // 处理短链接&文件记录
          that.introImgarrCutting = newOssPic.replace(localStorage.BaseOssUrl, '');
          const fileParams = {
            name: that.fileName,
            url: that.introImgarrCutting,
            uploader: localStorage.Id
          };
          postAddFile(fileParams).then(res => {
            if (res.resultCode == 1) {
              that.introOnePic.push(res.resultObj);
            }
          });
        };
        // 控制上传按钮显隐：最多5张，和原有逻辑一致
        that.introImgDisabled = that.introImgArr.length < 4;
        that.cropping = false;
        // 尺寸不符合：打开剪裁弹窗，标记为店铺简介模块剪裁
      }).catch(() => {
        const that = this;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          // 核心：标记当前剪裁为店铺简介模块，和原有模块隔离
          that.cropType = 'intro';
          that.$nextTick(() => {
            that.option.img = e.target.result;
            that.cropping = true;
            setTimeout(() => {
              document.querySelector('.crop-info').innerHTML = '1200 x 675';
            }, 300);
          });
        };
        return false;
      });
    },

    /**
     * 店铺简介-删除展示图片
     * 对齐原有deleteimg逻辑，控制上传按钮显隐
     */
    deleteIntroImg(index) {
      this.introImgArr.splice(index, 1);
      this.introOnePic.splice(index, 1);
      // 小于5张时启用上传按钮，和原有逻辑一致
      this.introImgDisabled = this.introImgArr.length < 5;
    },

    /**
     * 店铺简介-视频上传处理
     * 1:1对齐原有handleFile逻辑，仅修改目标字段
     */
    handleIntroFile(file) {
      // 格式校验：仅支持mp4，和原有规范完全对齐
      if (file.type.indexOf("mp4") === -1) {
        this.$swal({
          type: "warning",
          text: "请上传mp4格式的视频"
        });
        return false;
      }
      // 大小校验：最大50MB，和原有规范完全对齐
      if (file.size > 50 * 1024 * 1024) {
        this.$swal({
          type: "warning",
          text: "视频大小不能超过 50MB !"
        });
        return false;
      }

      // 上传状态&进度条初始化，和原有逻辑一致
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.introVideoFlag = true;
      this.introVideoUploadPercent = 0;
      // 专属定时器，和原有timer隔离
      this.introVideoTimer = setInterval(() => {
        if (this.introVideoUploadPercent >= 99) {
          clearInterval(this.introVideoTimer);
          return;
        }
        this.introVideoUploadPercent += 1;
      }, 50);

      // 复用原有视频上传接口
      const formData = new FormData();
      formData.append('file', file);
      uploadVedio(formData, 20).then(data => {
        if (data.resultCode == 1) {
          // 视频&封面回显到店铺简介专属字段
          this.introVideoImg = localStorage.BaseOssUrl + data.resultObj.r_png;
          this.introVideoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8;
          this.introVideoShortSrc = data.resultObj.r_m3u8;
          // 重置上传状态
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.introVideoFlag = false;
          this.introVideoUploadPercent = 0;
          clearInterval(this.introVideoTimer);
        } else {
          this.$swal({
            type: 'error',
            text: data.resultMsg
          });
          // 异常重置
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.introVideoFlag = false;
          this.introVideoUploadPercent = 0;
          clearInterval(this.introVideoTimer);
        }
      });
    },

    /**
     * 店铺简介-删除视频
     * 对齐原有delvideo逻辑，增加二次确认
     */
    delIntroVideo() {
      this.$swal({
        type: "warning",
        text: "确认删除店铺简介视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          // 清空店铺简介专属视频字段
          this.introVideoImg = '';
          this.introVideoSrc = '';
          this.introVideoShortSrc = '';
          if (this.introVideoTimer) {
            clearInterval(this.introVideoTimer);
          }
        }
      }).catch(() => { });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this
      this.$refs.cropper.getCropBlob(data => {
        var canvas = document.getElementById("canvasa");
        var ctx = canvas.getContext("2d");
        let _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = start;
        img.src = _URL.createObjectURL(data);
        function start() {
          canvas.width = 1200;
          canvas.height = 675;
          var w = img.width;
          var h = img.height;
          var sizer = Math.min((canvas.width / w), (canvas.height / h));
          ctx.drawImage(img, 0, 0, w, h, 0, 0, w * sizer, h * sizer);
          var dataURL = canvas.toDataURL('image/png');
          var getRes = dataURL;
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
          }
          // 修复：补全第二个文件名参数，和原有逻辑对齐
          var file = dataURLtoFile(getRes, 'crop_1200_675.png');
          // 核心分支：根据剪裁类型，回显到对应模块，原有逻辑完全不变
            // 店铺简介模块：剪裁后回显到简介图片列表
          that.beforeUploadIntroImg(file);
          // 重置剪裁类型标记
          that.cropType = '';
        }
      })
    },

      // 新版本上传oss预览
    newSeevideo(videoUrl) {
      // 优先级：传入的视频地址(店铺简介) > 原有店铺基本信息视频地址
      const targetUrl = videoUrl || this.videoSrc;

      // 非空拦截，避免无效地址报错
      if (!targetUrl) {
        this.$swal({
          type: "warning",
          text: "视频地址无效，无法播放"
        });
        return;
      }

      // 原有播放逻辑完全不变
      if (targetUrl.indexOf("blob:") != -1) {
        window.open(targetUrl);
      } else {
        this.palySeevideo(targetUrl);
      }
    },
    // 播放视频
    palySeevideo(url) {
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    // 返回
    goOneback() {
      this.$router.go(-1);
    },

    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },


  },
  
  mounted() {

  },
  beforeDestroy() {
    // 新增：店铺简介视频定时器清除
    if (this.introVideoTimer) {
      clearInterval(this.introVideoTimer);
    }
  }
};
</script>
<style scoped lang="less">
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor: pointer;
}

.spanimg {
  width: 100%;
  height: 100%;
}

.red {
  width: 80px;
  height: 100px;
  color: #F56C6C;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 600;
}

.redspan {
  background: #F56C6C;
  width: 130px;
  height: 2px;
  display: block;
  position: absolute;
  top: 40px;
  left: -23px;
}

.nored {
  width: 80px;
  height: 100px;
  text-align: center;
  line-height: 30px;
  font-size: 17px;
  font-weight: 500;
}

.spanflex {
  display: flex;
  justify-content: space-between;
}

.choice {
  cursor: pointer;
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}

.choice1 {
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: not-allowed;
}

.choice:hover {
  border-color: #F56C6C;
  color: #F56C6C;
}

.span {
  display: inline-block;
  width: 60px;
  height: 35px;
  line-height: 35px;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #F56C6C;
  border-radius: 5px;
  margin-left: 15px;
}

.span:hover {
  background: #F56C6C;
  color: #fff;
  transform: 1s;
}

.bdname {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background: #dedede;
  margin-top: 20px;
}

.check_box {
  padding-left: 15px;
  height: 200px;
  overflow: hidden;
  overflow-y: scroll;
}

.shezhi {
  width: 80px;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}

.allchange {
  height: 35px;
  background: #f6f7f9;
  padding-left: 20px;
  margin-top: 30px;
}

// 店铺logo
.avatar-uploader-dpLogo .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-dpLogo .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-dpLogo {
  height: 80px;
}

.avatar-dpLogo {
  width: 80px;
  height: 80px;
  display: block;
}

.avatar-uploader-dpLogo .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px solid #eeeeee;
}

// 展示图片
.avatar-uploader-zstp .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-zstp {
  width: 100px;
  height: 50px;
  display: block;
}

.avatar-uploader-zstp .avatar-uploader-icon {
  width: 80px;
  line-height: 80px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  border: 1px solid #eeeeee;
}

.chooseDia {
  width: 740px;
  height: 360px;
  background: #fff;
  border: 1px solid #f6f6f6;
  font-size: 12px;
  margin: auto;

  .searchRight {
    width: 100%;
    height: 360px;
    overflow: hidden;
    text-align: left;

    .searchTop {
      padding: 20px 20px 15px 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #f6f6f6;
      overflow: hidden;

      span {
        display: inline-block;
        cursor: pointer;
        margin: 0 20px 10px 10px;
      }

      /deep/ .el-input {
        width: 240px;
        height: 35px;
        background: #fff;
        margin-top: -10px;
        float: right;

        .el-input__inner {
          height: 35px;
          border: 1px solid #ededed;
        }
      }

      p {
        margin-top: 20px;

        /deep/ .el-input {
          float: none;
          width: 180px;
          height: 35px;
        }
      }
    }

    .searchBot {
      box-sizing: border-box;
      padding: 0 20px;
      overflow-y: scroll;

      p {
        display: inline-block;
        float: left;
        padding: 8px;
        background: #f0f0f0;
        margin-right: 15px;
        margin-bottom: 15px;
      }
    }
  }
}

.changeColor {
  color: #F56C6C;
  cursor: pointer;
}

.brandColor {
  background: #F56C6C !important;
  color: #fff !important;
}

// 店铺管理员
.administrators {
  width: 90%;
  font-size: 17px;
  padding: 10px 0;
}

.administrators span {
  font-size: 14px;
  font-weight: normal;
  margin-left: 10px;
}

// 主营品牌
.mainBrand {
  display: flex;
  width: 80%;
  margin-top: 10px;
}

.brandTable {
  width: 60px;
  margin: 5px 0;
}

// ********************************************************

.choice {
  display: inline-block;
  width: 80px;
  height: 40px;
  border: 1px solid #eee;
  color: #888;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}

.choice:hover {
  border-color: #F56C6C;
  color: #F56C6C;
}

/* 免预约 & 需预约 */
.myyxyy {
  width: 80%;
  line-height: 40px;
  border-bottom: 2px solid #eee;
}

/* 预约服务 */
.yyfwClass {
  width: 360px;
  height: 58px;
  line-height: 55px;
  border: 1px solid #eee;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
  position: relative;
}

.yyfwImg {
  width: 50px !important;
  height: 50px !important;
  margin: 5px 0;
  border-radius: 3px;
}

.yyfwInput {
  border-right: 1px solid #eee;
  padding-right: 30px;
}

/* 上传icon */
.yyfwIcon {
  width: 360px;
  line-height: 50px;
  border: 1px solid #eeeeee;
  font-size: 25px;
  color: #8c939d;
  text-align: center;
}

/* 穿梭框 */
.shuttle {
  border: 1px solid #eee;
}

.TLeft {
  width: 49%;
  float: left;
  height: 220px;
  overflow-y: auto;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 40px;
  box-sizing: border-box;
}

.TLeft p {
  /* margin-left: 20px; */
  color: #000;
  font-size: 12px;
  width: 90%;
}

/* 选择框 */
.TLeft .left_img {
  width: 16px;
  height: 16px;
  z-index: 999;
  margin-bottom: 6px;
  cursor: pointer;
}

.border_r {
  border-left: 1px solid #eee;
  height: 220px;
  overflow-y: auto;
  padding-left: 20px;
  padding-bottom: 20px;
}

.TRight {
  position: relative;
  width: 68%;
  /* height: 50px; */
  /* display: inline-block; */
}

.TRight p {
  background: #f2f2f2;
  text-align: center;
  /* margin-top: 18px; */
  margin-left: 13px;
  padding: 5px 15px;
}

.TRight img {
  position: absolute;
  top: -8px;
  right: -8px;
  cursor: pointer;
}

/* 角色列表 */
.shut p {
  border-right: 1px solid #eee;
  height: 50px;
  background: #bbb;
  line-height: 50px;
  padding-left: 20px;
  font-size: 12px;
  color: #000;
  opacity: 0.49;
  margin: 15px 0 0 0;
}

// 店铺简介
.form-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  width: 120px;
  flex-shrink: 0;
}

/* 多行文本框 */
.form-textarea {
  min-height: 80px;
  padding: 8px 12px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  flex: 1;
}

.form-textarea:focus {
  border-color: #ff6b00;
  outline: none;
}

/* 图片上传组 */
.image-upload-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.image-item {
  position: relative;
  width: 120px;
  height: 68px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #dcdcdc;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-delete {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 18px;
  height: 18px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
}

.image-upload-btn,
.video-upload-btn {
  width: 68px;
  height: 68px;
  border: 1px dashed #dcdcdc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  transition: all 0.2s;
}

.image-upload-btn:hover,
.video-upload-btn:hover {
  border-color: #ff6b00;
  color: #ff6b00;
}

/* 表单提示文字 */
.form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 6px;
}

.optional-tip {
  color: #ff6b00;
  margin-left: 4px;
}
</style>


// WEBPACK FOOTER //
// dpjj.vue?a8d8325c